<template>
  <div class="flexing flex-col w-full">
    <form class="w-full p-6 space-y-6" @submit.prevent>
      <h1 class="text-texts-standard-important font-medium text-36">
        {{ $t('homepage.forgotPassword') }}
      </h1>
      <p class="text-texts-standard-default text-28 font-medium !mt-2">
        {{ $t('homepage.forgotPasswordEmailText') }}
      </p>
      <div>
        <div class="v-field--variant-outlined relative">
          <input
            v-focus
            :value="email"
            :class="{ 'is-error': errors.size > 0 }"
            type="text"
            name="email"
            :placeholder="$t('homepage.email')"
            :disabled="isLoading"
            @input="$emit('update:email', ($event.target as HTMLInputElement).value)"
          />
          <div class="v-field__outline" v-html="inputLabel('homepage.email')" />
        </div>
        <div class="validation-text__wrapper">
          <div class="validation-text" :class="{ 'validation-text--error': errors.size > 0 }">
            <span v-for="(error, i) in errors" :key="i">
              {{ error }}
            </span>
          </div>
        </div>
      </div>
      <app-button
        type="submit"
        btn-type="confirm"
        :disabled="isLoading || email.length === 0 || errors.size > 0"
        @click="$emit('submit')"
      >
        {{ $t('homepage.send') }}
        <component-loading class="absolute inset-0" :is-loading="isLoading" />
      </app-button>
      <p class="text-texts-standard-additional text-28">
        <span v-if="showBackBtn" class="uppercase underline cursor-pointer" @click="$emit('back')">
          {{ $t('homepage.back') }}
        </span>
        <template v-else>
          {{ $t('homepage.rememberPassword') }}
          <span
            class="text-texts-standard-default font-bold uppercase underline cursor-pointer ml-2"
            @click="$emit('login')"
          >
            {{ $t('homepage.loginBtn') }}
          </span>
        </template>
      </p>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import ComponentLoading from '../GlobalComponents/ComponentLoading.vue'

export default defineComponent({
  name: 'LoginFormForgottenPwd',
  components: {
    ComponentLoading,
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object as PropType<Set<string>>,
      default: () => new Set<string>(),
    },
    showBackBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:email', 'submit', 'back', 'login'],
  methods: {
    inputLabel(translatedLabel: string): string {
      return `
        <div class="v-field__outline__start"></div>
        <div class="v-field__outline__notch">
          <label class="v-label v-field-label" aria-hidden="true">
            ${this.$t(translatedLabel)}
          </label>
        </div>
        <div class="v-field__outline__end"></div>
      `
    },
  },
})
</script>

<style lang="scss" scoped>
.\!mt-2 {
  margin-top: 0.25rem !important;
}
</style>
